import { useState } from "react";
import styled from "styled-components";
import { NotesDrawer } from "./NotesDrawer";
import { NotesModal, countOpenTasks } from "./Notes";

export function NotesDrawerShell({
  isOpen,
  onClose,
  recordName,
  openTaskCount: openTaskCountProp,
  ...notesProps
}) {
  const [liveOpenCount, setLiveOpenCount] = useState(null);
  const openCount = liveOpenCount ?? openTaskCountProp ?? 0;

  const supplementary =
    openCount > 0 ? <OpenTasksBadge>Open Tasks ({openCount})</OpenTasksBadge> : null;

  return (
    <NotesDrawer isOpen={isOpen} title={recordName} supplementary={supplementary} onClose={onClose}>
      <NotesModal
        {...notesProps}
        isOpen={isOpen}
        recordName={recordName}
        onOpenTaskCountChange={setLiveOpenCount}
      />
    </NotesDrawer>
  );
}

export { countOpenTasks };

const OpenTasksBadge = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--DARK-BLUE, #1249bf);
  white-space: nowrap;
`;
